import { SessionForm } from "@/components/session/session-form.tsx";
import { Session } from "@/lib/api/sessions.ts";
import { X } from "lucide-react";

interface SessionEditModeProps {
  closeForm: () => void;
  session: Session;
  className?: string;
  handleSessionUpdated?: () => void;
}

export function SessionEditMode({
  session,
  closeForm,
  className,
  handleSessionUpdated,
}: SessionEditModeProps) {
  return (
    <div className={className}>
      <div className="flex flex-row items-center justify-between">
        <p className="mb-2 text-base font-bold">
          Reschedule{" "}
          {session?.mentee?.name
            ? `Session with ${session.mentee.name}`
            : session.title}
        </p>

        <button onClick={closeForm}>
          <X size={24} className="text-gray-600" />
        </button>
      </div>

      <SessionForm
        closeForm={closeForm}
        menteeId={session.mentee?.id}
        session={session}
        handleSessionUpdated={handleSessionUpdated}
      />
    </div>
  );
}
